import { render, staticRenderFns } from "./DictSearchSelect.vue?vue&type=template&id=32b435ec&scoped=true"
import script from "./DictSearchSelect.vue?vue&type=script&lang=js"
export * from "./DictSearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b435ec",
  null
  
)

export default component.exports